/**
 * The app footer's words (components/nav/AppFooter): who makes it, the product's name and the build's day. Pure.
 */
import { formatDay } from "@/lib/plant-days";

/**
 * The date the bundle was built on, the build machine's UTC date ("YYYY-MM-DD"), stamped by vite.config (define); ""
 * where it is not (tests, an old build). Not a plant day: no plant clock is involved (#1234 review, LOW).
 */
export const BUILT_ON: string = typeof __APP_BUILT_ON__ === "string" ? __APP_BUILT_ON__ : "";

/** The footer's line: "© 2026 Sahas Labs. Foundry Twin, built 6 Oct 2026." */
export function footerLine(productName: string, year: number, builtOn: string): string {
  const built = /^\d{4}-\d{2}-\d{2}$/.test(builtOn) ? `, built ${formatDay(builtOn)}` : "";
  return `© ${year} Sahas Labs. ${productName}${built}.`;
}
